import React, { SVGProps } from 'react';

const EmailIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 20"
			fill="none"
			width="100%"
			height="100%"
			{...props}
		>
			<path
				d="M21.5996 0.200195C22.9222 0.200195 23.9998 1.27705 24 2.59961V17C23.9999 18.3226 22.9223 19.3994 21.5996 19.3994H2.40039C1.07775 19.3994 0.000130984 18.3226 0 17V2.59961C0.000193362 1.27705 1.07779 0.200195 2.40039 0.200195H21.5996ZM12.626 10.8242C12.2419 11.059 11.7581 11.059 11.374 10.8242L2.40039 5.33887V17H21.5996V5.33887L12.626 10.8242ZM12 8.39355L21.4805 2.59961H2.51953L12 8.39355Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default EmailIcon;
